
































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";

@Component({
  components: {
    "ticket-detail-cell": () =>
      import("@/components/app/global/tickets/ticketDetailCell.vue"),
    "ticket-participants-avatars": () =>
      import("@/components/app/global/tickets/ticketParticipantsAvatars.vue")
  }
})
export default class TicketHeaderLeadDetails extends Vue {
  // Inject

  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;

  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;

  // Computed

  public get ticketData() {
    return this.$ticketData();
  }

  public get lead() {
    return this.ticketData.ticket.lead;
  }
}
